import { RECORD_DATA_TYPE } from '@demandproai/shared';
import useUploadQueue from './useUploadQueue';
import usePresignedUrlCount from "./usePresignedUrlCount";
import { buildCaseFieldUpdateCallback } from '../utils/uploadUtils';
import { prepFileMetaDataForDedicatedUpload } from '../utils/helper';

export default function useDedicatedFileUpload(caseId, caseRecordType) {
    const { isLoading, queueFiles } = useUploadQueue(caseId);
    const { incrementPresignedUrlCount, decrementPresignedUrlCount } = usePresignedUrlCount();

    const dedicatedFileUpload = async (files, updateCasePayload = null) => {
        try {
            const callback = updateCasePayload ? buildCaseFieldUpdateCallback(updateCasePayload) : null;
            const { filesWithMetadata } = await queueFiles({ files, caseRecordType, callback });
            return filesWithMetadata;
        } catch (error) {
            decrementPresignedUrlCount(files.length);
            throw error;
        }
    };

    const dedicatedImageUpload = async (imageFiles, updateCasePayload = null) => {
        try {
            const callback = updateCasePayload ? buildCaseFieldUpdateCallback(updateCasePayload) : null;
            const { filesWithMetadata } = await queueFiles({
                files: imageFiles,
                caseRecordType: RECORD_DATA_TYPE.IMAGE,
                callback,
            });
            return filesWithMetadata;
        } catch (error) {
            decrementPresignedUrlCount(imageFiles.length);
            throw error;
        }
    };

    const handleFileSelection = (files) => {
        dedicatedFileUpload(files);
    };

    const fileUploadForCaseKey = async (fileUploadObj, fileKey) => {
        const fileArray = fileUploadObj?.file;
        if (!fileArray || fileArray.length === 0) {
            console.log('❌ No files provided');
            return;
        }
        console.log("uploading files", fileUploadObj);

        const prepFiles = prepFileMetaDataForDedicatedUpload(fileArray);
        const fileCount = prepFiles.length;

        console.log('📤 Starting file upload, count:', fileCount);
        incrementPresignedUrlCount(fileCount);

        const updateCasePayload = {
            fieldKey: fileKey,
            action: 'update'
        };
        console.log('🚀 Calling dedicatedFileUpload with payload:', updateCasePayload);

        const dedicatedFiles = await dedicatedFileUpload(prepFiles, updateCasePayload);
        console.log('✅ Upload complete, dedicatedFiles:', dedicatedFiles);

        decrementPresignedUrlCount(fileCount);
        console.log('🎉 File upload finished');
    };
    
    return {
        isLoading,
        handleFileSelection,
        dedicatedFileUpload,
        dedicatedImageUpload,
        completeFileUpload: (count) => decrementPresignedUrlCount(count),
        startFileUpload: (count) => incrementPresignedUrlCount(count),
        fileUploadForCaseKey
    };
}
